export const insuranceReviewsUids = {
  donorInsuranceRecords: 'donor-insurance-records',
  donorInsuranceReviewDetails: 'donor-insurance-review-details',
  donorInsuranceReviewDecision: 'donor-insurance-review-decision',
} as const;

export type InsuranceReviewsUid =
  typeof insuranceReviewsUids[keyof typeof insuranceReviewsUids];
